<template>
  <b-modal id="modal-search"
          title="통합조회"
          header-class="popup_header1"
           content-class="md_modal_content"
           :visible="visible"
           @hidden="onCancel();"
           @show="onShow"
           hide-footer centered>
      <div style="display: flex; flex-direction: column; align-self: center">
        <b-input-group class="container mb-2" style="font-family: $korean_gd_14_r; border: 2px solid #267fff; padding: 0;">
          <b-form-input v-model="search_name"
                        style="height: 40px; font-size: 16px; font-family: KoreanGD14R; text-align: center;"
                        placeholder='지번 주소를 입력해주세요.'
                        @keydown.enter="onSearch">
          </b-form-input>
          <b-input-group-append>
            <b-button
              variant="white"
              class="transparent"
              style="height: 40px;border: 1px solid #ced4da;"
              @click="onSearch"
            >
              <b-icon icon="search" variant="primary"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <span class="no_item2">조회 정보가 많을 시 다소 시간이 걸릴 수 있습니다.</span>
      </div>
  </b-modal>
</template>

<script>

export default {
  name: "SearchPopup",
  components: {},
  props:["visible"],
  data() {
    return {
      self: this,
      search_name: '',
    }
  },
  mounted() {
  },
  methods:{
    onShow() {
      this.search_name = '';
    },
    onCancel()  {
      this.$emit('update:visible', false);
    },
    onSearch() {
      this.$emit('search', this.search_name);
      this.$emit('update:visible', false);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/Modal.scss";

.no_item2 {
  color: $red;
  font-size: $fs_15;
  font-family: $korean_gd_14_r;
  //margin-right: 15px;
  align-self: flex-end;
}

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SearchPopup.vue